/* Keeps installed/home-screen copies on the latest published build automatically. */
const MANIFEST = "/asset-manifest.json";
const POLL_MS = 60_000;

let currentSignature = null;
let reloading = false;

const reload = () => {
  if (reloading) return;
  reloading = true;
  window.location.reload();
};

async function signature() {
  try {
    const res = await fetch(`${MANIFEST}?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    return JSON.stringify(data.files || data);
  } catch {
    return null;
  }
}

async function check(registration) {
  const next = await signature();
  if (!next) return;
  if (currentSignature === null) {
    currentSignature = next;
    return;
  }
  if (next !== currentSignature) {
    try {
      await registration?.update();
    } catch {
      /* ignore */
    }
    reload();
  }
}

export function startAutoUpdate() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  navigator.serviceWorker.addEventListener("controllerchange", reload);

  navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((registration) => {
    const run = () => check(registration);
    run();
    setInterval(run, POLL_MS);
    window.addEventListener("focus", run);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") run();
    });
  }).catch(() => {});
}
